/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import React from 'react';
import { ViewProps } from 'react-native';
import PressableView from '@airasia-phoenix/react-native/components/PressableView';

interface LinkProps extends ViewProps {
  url: string;
  children: React.ReactNode;
  onPress?: () => void;
  boxShadowBorderRadius?: number;
}

export const Link: React.FC<LinkProps> = ({
  url,
  children,
  style,
  onPress,
  boxShadowBorderRadius,
  ...props
}) => {
  return (
    <PressableView
      boxShadowBorderRadius={boxShadowBorderRadius ?? 4}
      onPress={onPress}
      {...({
        accessibilityRole: 'link',
        href: url,
        target: '_blank',
        hrefAttrs: { target: '_blank' },
        style: [{ cursor: 'pointer' }, style],
        ...props,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any)}
    >
      {children}
    </PressableView>
  );
};

export default Link;
